/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/widgets/uploadInfo/uploadInfoView',
        'assets/js/modules/designFacePreview/designFacePreview',
        'assets/js/modules/designFacePreview/model/designFacePreviewModel',
        'assets/js/modules/designFacePreview/guideLines/lineLegendPresenter'
    ],
    function($, _, UploadInfoView, DesignFacePreview, DesignFacePreviewModel, LineLegendPresenter) {
        return UploadInfoView.extend({
            /**
             * @param {object} zones
             * @param {string} linearUnitSign
             * @param {number} realSafeWidth
             * @param {number} realSafeHeight
             * @returns {object}
             */
            getGuideLinesOptions: function(zones, linearUnitSign, realSafeWidth, realSafeHeight) {
                return {
                    bleedZone: {
                        legend: {
                            text: 'Bleed Size: ' + zones.bleedWidth + linearUnitSign + ' x ' + zones.bleedHeight + linearUnitSign,
                            color: '#008000',
                            presenter: LineLegendPresenter
                        }
                    },
                    safeZone: {
                        legend: {
                            text: 'Safe Zone',
                            color: '#ff0000',
                            presenter: LineLegendPresenter
                        }
                    }
                };
            }
        });
    }
);
